/* The blog's posts, from one file.

   `blog/posts.json` is the only place a post's path, title, date and summary
   are written. The blog page lists them, the home page shows the newest, each
   post reads its own header from here, and `llms.txt` lists them from Ruby —
   so a title or a date cannot say one thing on the index and another on the
   post. JSON rather than a module because Ruby reads it too.

   A post also needs its own route, controller action and line in
   `config/prerender.json`; `blog_test` fails by name until all three agree. */
import posts from '~/marketing/blog/posts.json';

// Newest first; posts published the same day keep the file's order, because
// `sort` is stable. `PagesController.blog_posts` orders them the same way.
export const POSTS = [...posts].sort((a, b) => b.published.localeCompare(a.published));

export const latestPosts = (n = 3) => POSTS.slice(0, n);

export const postAt = (path) => POSTS.find((p) => p.path === path);

/* "How these numbers are counted", linked from the dashboard and the free
   report. Read through `postAt` so a renamed post fails the build here rather
   than leaving two screens linking to nothing. */
const method = postAt('/blog/how-to-measure-ai-visibility');
if (!method) throw new Error('blog.js: the post explaining how figures are counted is not listed');
export const METHOD_POST = method.path;

/* "How to get listed where AI assistants look", linked from the Overview's
   "What you can do" card — read the same way, for the same reason. */
const listed = postAt('/blog/get-listed-where-ai-assistants-look');
if (!listed) throw new Error('blog.js: the post on getting listed is not listed');
export const LISTED_POST = listed.path;

/* The benchmark, linked from the home page's industry section, whose cards
   quote its findings — read the same way, for the same reason. */
const benchmark = postAt('/blog/local-services-benchmark');
if (!benchmark) throw new Error('blog.js: the benchmark post is not listed');
export const BENCHMARK_POST = benchmark.path;
